var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"suggest suggest--fixed",attrs:{"to":"/account/referrals?utm_source=campsitead"}},[_c('img',{attrs:{"src":require("images/referral-program-small.jpg"),"alt":"Referral Program","loading":"lazy"}}),_vm._v(" "),_c('span',{staticClass:"suggest__text"},[_vm._v("Get free Campsite Pro when you refer a friend.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }